import styled from 'styled-components';

export const Section04_Styled = styled.section`
  padding: 60px 0;
  background-color: #222127;
  overflow: hidden;

  @media screen and (min-width: 992px) {
    padding: 120px 0;
  }
`;

export const Article = styled.article`
  margin-bottom: 56px;

  &:first-child {
    margin-bottom: 60px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 992px) {
    display: grid;
    grid-column: 1/13;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 16px;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const TextBlock = styled.div`
  margin-bottom: 40px;

  @media screen and (min-width: 992px) {
    grid-column: 2/6;
    margin-bottom: 0;

    &.desktop-swap {
      grid-column: 8/12;
      grid-row: 1;
    }
  }

  .scopeList {
    padding-left: 0;
    margin: 0;
    font-size: 16px;
    line-height: 27.2px;
    list-style: none;
    color: #c9c9cc;

    li {
      position: relative;
      padding-left: 20px;
      margin-bottom: 10px;

      &:before {
        content: '';
        position: absolute;
        top: 12px;
        left: 0;
        width: 6px;
        height: 6px;
        background-color: #eb5424;
      }
    }
  }
`;

export const CategoryTitle = styled.div`
  margin: 0 0 20px;
  font-size: 12px;
  font-weight: 600;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  line-height: 1.7;
  text-transform: uppercase;
  color: #eb5424;

  @media screen and (min-width: 992px) {
    font-size: 14px;
    margin: 0 0 40px;
  }
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 1.5;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    margin: 0 0 32px;
    font-size: 32px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #d0d2d3;

  @media screen and (min-width: 992px) {
    margin-bottom: 24px;
  }
`;

export const Figure = styled.figure`
  display: flex;
  flex-direction: column;

  .my-api {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;

    @media screen and (min-width: 992px) {
      width: 655px;
      max-width: 655px;
    }
  }

  @media screen and (min-width: 992px) {
    grid-column: 8/12;

    &.desktop-swap {
      grid-column: 2/6;
      grid-row: 1;
    }
  }

  img {
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-04/styled.js